// extracted by mini-css-extract-plugin
module.exports =  {"anchorLink":"anchorLink__YaJQ0"};